// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Extraction-Compare-module__consensusHeader";
var _2 = "webpack-containers-Extraction-Compare-module__consensusHeading";
var _3 = "webpack-containers-Extraction-Compare-module__container webpack-containers-Extraction-splitable-module__container";
var _4 = "webpack-containers-Extraction-Compare-module__error";
var _5 = "webpack-containers-Extraction-Compare-module__forms";
var _6 = "webpack-containers-Extraction-Compare-module__header webpack-containers-Extraction-splitable-module__header";
var _7 = "webpack-containers-Extraction-Compare-module__split webpack-containers-Extraction-splitable-module__split";
var _8 = "webpack-containers-Extraction-Compare-module__tabPanel";
export { _1 as "consensusHeader", _2 as "consensusHeading", _3 as "container", _4 as "error", _5 as "forms", _6 as "header", _7 as "split", _8 as "tabPanel" }
